import { Box } from '@primerai/thread';

import PasswordStrengthBar from './PasswordStrengthBar';
import { MIN_PASSWORD_METER_LENGTH } from '~/components/password/constants';

type PasswordMeterProps = {
  passwordLength: number;
};

const getMeterText = (passwordLength: number) => {
  if (passwordLength === 0) {
    return 'Password must be at least 9 characters';
  } else if (passwordLength < MIN_PASSWORD_METER_LENGTH) {
    return `Enter at least ${
      MIN_PASSWORD_METER_LENGTH - passwordLength
    } more characters`;
  }
};

//TO-DO: fix this linter error
const PasswordMeter = ({ passwordLength }: PasswordMeterProps) => {
  let color = '';
  let activeIndex = 0;
  switch (true) {
    case passwordLength >= 1 && passwordLength < 5:
      color = '$alerts.danger';
      activeIndex = 0;
      break;
    case passwordLength >= 5 && passwordLength <= 6:
      color = '$orangeScale.o7';
      activeIndex = 1;
      break;
    case passwordLength >= 7 && passwordLength < 9:
      color = '$blueScale.b7';
      activeIndex = 2;
      break;
    case passwordLength >= 9:
      color = '$greenScale.g7';
      activeIndex = 3;
      break;
    default:
      color = '$grayScale.g3';
      activeIndex = 4;
      break;
  }

  return (
    <Box minHeight="32px">
      <PasswordStrengthBar
        activeIndex={activeIndex}
        barColor={color}
        passwordText={getMeterText(passwordLength)}
      />
    </Box>
  );
};

export default PasswordMeter;
